import { c as _c } from "react/compiler-runtime";
import { cn } from "@workspace/ui/lib/utils";
import type { SVGProps } from "react";
export interface MagnusLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

/**
 * The Magnus mark, rendered by the collapsible tool-group header. Same SVG
 * as the magnus-floating block's logo — duplicated because registry blocks
 * are self-contained (no cross-block imports).
 */
export function MagnusLogo(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M375.1 124.2h91.1v91.1h-91.1v-91.1zm91.1 180.5l-91.6-89.4v178.8h91.6v-89.4zm-91.6-88.9h-74.1v178.3h-91.6V215.8h-71.5v178.3H45.8V124.7l236.9-.5 92 91.6z" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <svg aria-label="Magnus" className={t1} fill="currentColor" viewBox="0 0 512 512" {...props}>{t2}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}